"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorReporter = exports.ErrorReporterContext = exports.SentryErrorReporter = exports.ConsoleErrorReporter = void 0;
var browser_1 = require("@sentry/browser");
var react_1 = require("react");
var react_2 = __importDefault(require("react"));
var ConsoleErrorReporter = /** @class */ (function () {
    function ConsoleErrorReporter() {
        this.report = function (e) {
            console.error(e);
        };
        this.reportApolloError = function (e) {
            console.error(e);
        };
    }
    return ConsoleErrorReporter;
}());
exports.ConsoleErrorReporter = ConsoleErrorReporter;
var SentryErrorReporter = /** @class */ (function () {
    function SentryErrorReporter() {
        this.report = function (e) {
            console.error(e);
            (0, browser_1.captureException)(e);
        };
        this.reportApolloError = function (e) {
            console.error(e);
            (0, browser_1.captureException)(Object.assign(new Error(e.message), {
                graphqlErrors: JSON.stringify(e.graphQLErrors),
                networkError: JSON.stringify(e.networkError),
                extraInfo: JSON.stringify(e.extraInfo),
            }));
        };
    }
    return SentryErrorReporter;
}());
exports.SentryErrorReporter = SentryErrorReporter;
// TODO: Provide functionality to send errors to sentry.
exports.ErrorReporterContext = react_2.default.createContext(new ConsoleErrorReporter());
function useErrorReporter() {
    var context = (0, react_1.useContext)(exports.ErrorReporterContext);
    return context;
}
exports.useErrorReporter = useErrorReporter;
//# sourceMappingURL=error-reporter.js.map